import { http, normalizeListPayload } from './http';

export async function fetchStandardClients() {
  const response = await http.get('/api/clients-standard/');
  return normalizeListPayload(response.data);
}

